<template>
    <section class="cta-banner">
        <div class="container cta-banner__container">
            <p class="cta-banner__copy">{{ copy }}</p>

            <AppButton :text="buttonText" :link="buttonLink" />
        </div>
    </section>
</template>

<script>
import AppButton from "@/components/ui/AppButton";

export default {
    name: 'CallToAction',
    props: {
        copy: String,
        buttonText: String,
        buttonLink: String,
    },
    components: {
        AppButton
    }
}
</script>